import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box, useMediaQuery } from '@mui/material';
import stepperStyles from './Stepper.styles';
import StepperContext from '../Context/StepperContext';

//Customhook
import { useTranslation } from '../../hooks/useTranslation';

function StepperBar(props) {
	const location = useLocation();
	const showBox =
		/^\/accounts(\/.*)?$/.test(location.pathname) ||
		/^\/home\/?$/.test(location.pathname) ||
		/^\/NoAccountFound(\/.*)?$/.test(location.pathname);
	const theme = useTheme();
	const mobileScreen = useMediaQuery(theme.breakpoints.down('md'));
	const { translations } = useTranslation();
	const { currentStep } = useContext(StepperContext);

	// To prevent flicker
	if (!translations || !translations.common || !translations.common.labels) {
		return null;
	}

	// In isFlowChange: 2 steps (Register → Approve Consents)
	// In normal flow: 3 steps (Register → Select Accounts → Approve Consents)
	const totalSteps = global.isFlowChange === 'true' ? 2 : 3;

	// Check if on consent page
	const isOnConsentPage = location.pathname.includes('/payment-consent');
	const isOnConsentRenewPage = location.pathname.includes('/consent-renew');

	// Calculate progress
	let progressPercentage;

	// Allow overriding progress percentage via props
	if (props.progressPercentage !== undefined) {
		progressPercentage = props.progressPercentage;
	} else if (global.isFlowChange === 'true' || global.renewConsentId) {
		// In isFlowChange flow, use pathname-based logic
		if (isOnConsentPage || isOnConsentRenewPage) {
			// On consent page, show 90%
			progressPercentage = 90;
		} else {
			// On login or discovery page, show 50%
			progressPercentage = 50;
		}
	} else {
		// Normal flow calculation, cap at 90% (never fill completely)
		progressPercentage = Math.min(((currentStep + 1) / totalSteps) * 100, 90);
	}

	const isDark =
		props.customDetails?.darkTheme === true || theme.palette.mode === 'dark';
	let loginPage = props.login;

	return (
		<Box
			sx={{
				...stepperStyles.stepperContainer,
				...(loginPage && {
					position: 'absolute',
					top: global.renewConsentId ? 'calc(2.3rem + 0.5rem)' : 'calc(1rem)',
					left: '0',
					padding: global.renewConsentId
						? '0px 20px 0px 20px !important'
						: '20px !important',
					paddingTop: global.renewConsentId ? '0px !important' : undefined,
				}),
				backgroundColor: showBox ? theme.palette.primary.light : 'transparent',
				display: 'flex',
				justifyContent: 'center',
			}}
		>
			<Box
				sx={{
					width: loginPage
						? mobileScreen
							? '98%'
							: '72%'
						: mobileScreen
						? '95%'
						: '60%',
					height: '8px',
					backgroundColor: isDark ? '#2D2D2D' : '#E0E0E0',
					borderRadius: '4px',
					overflow: 'hidden',
				}}
			>
				<Box
					sx={{
						width: `${progressPercentage}%`,
						height: '100%',
						backgroundColor:
							props.customDetails?.primaryColor || theme.palette.primary.main,
						transition: 'width 0.3s ease-in-out',
						borderRadius: '4px',
					}}
				/>
			</Box>
		</Box>
	);
}

export default StepperBar;
